import { Dropdown } from "primereact/dropdown";
import { FC } from "react";
import Form from "react-bootstrap/Form";
import { isFieldRequired } from "../../helpers/utils";
import CommonFormLabel from "./CommonFormLabel";
import { MdKeyboardArrowDown } from "react-icons/md";
import { MdKeyboardArrowUp } from "react-icons/md";

export interface IThemeCustomSelect {
  controlId?: any;
  label?: any;
  handleChange?: any;
  handleBlur?: any;
  errorsField?: any;
  touched?: any;
  value?: any;
  data?: any;
  placeHolder?: string;
  disabled?: boolean;
  filter?: boolean;
  filterPlaceholder?: string;
  inputClassName?: any;
  id?: any;
  wrapperClassname?: any;
  validationSchema?: any;
  tooltip?: any;
  tooltipContent?: any;
  emptyMessage?: string;
}

/**
 * Custom component for Select
 *
 * @param {{ controlId: any; label: any; handleChange: any; handleBlur: any; errorsField: any; touched: any; value: any; data: any; placeHolder: any; disabled: any; filter: any; filterPlaceholder: any; inputClassName: any; ... 4 more ...; tooltipContent: any; }} param0
 * @param {*} param0.controlId
 * @param {*} param0.label
 * @param {*} param0.handleChange
 * @param {*} param0.handleBlur
 * @param {*} param0.errorsField
 * @param {*} param0.touched
 * @param {*} param0.value
 * @param {*} param0.data
 * @param {*} param0.placeHolder
 * @param {*} param0.disabled
 * @param {*} param0.filter
 * @param {*} param0.filterPlaceholder
 * @param {*} param0.inputClassName
 * @param {*} param0.id
 * @param {*} param0.wrapperClassname
 * @param {*} param0.validationSchema
 * @param {*} param0.tooltip
 * @param {*} param0.tooltipContent
 * @returns
 */

const ThemeCustomDropdown: FC<IThemeCustomSelect> = ({
  controlId,
  label,
  handleChange,
  handleBlur,
  errorsField,
  touched,
  value,
  data,
  placeHolder,
  disabled,
  filter,
  filterPlaceholder,
  inputClassName,
  id,
  wrapperClassname,
  validationSchema,
  tooltip,
  tooltipContent,
  emptyMessage,
}: IThemeCustomSelect) => {
  const isRequired = validationSchema
    ? isFieldRequired(validationSchema, controlId)
    : false;
  return (
    <Form.Group className={wrapperClassname}>
      {label && (
        <CommonFormLabel
          controlId={controlId}
          label={label}
          isRequired={isRequired}
          tooltip={tooltip}
          tooltipContent={tooltipContent}
        />
      )}
      <div className="position-relative">
        <Dropdown
          id={id}
          inputId={controlId}
          name={controlId}
          value={value}
          options={data}
          optionLabel="label"
          placeholder={placeHolder}
          className={
            errorsField && touched
              ? `p-invalid is-invalid w-100 ${inputClassName || ""}`
              : `w-100 ${inputClassName || ""}`
          }
          onChange={(e) => {
            handleChange(e, controlId);
          }}
          onBlur={handleBlur ? handleBlur(controlId) : ""}
          disabled={disabled}
          filter={filter}
          filterPlaceholder={filterPlaceholder ?? "Search"}
          resetFilterOnHide={true}
          dropdownIcon={<MdKeyboardArrowDown size={24} />}
          collapseIcon={<MdKeyboardArrowUp size={24} />}
          emptyMessage={emptyMessage ?? ""}
        />
        <Form.Control.Feedback
          type="invalid"
          className={errorsField && touched ? "d-block" : "d-none"}
        >
          {errorsField}
        </Form.Control.Feedback>
      </div>
    </Form.Group>
  );
};

export default ThemeCustomDropdown;
